import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconNewCalendar = ({ className, height, width, fill }: IconInterface) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 20 20" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M5.461 2.4248C5.461 2.14866 5.68486 1.9248 5.961 1.9248H6.861C7.13714 1.9248 7.361 2.14866 7.361 2.4248V3.82484H13.0608V2.4248C13.0608 2.14866 13.2847 1.9248 13.5608 1.9248H14.4608C14.737 1.9248 14.9608 2.14866 14.9608 2.4248V3.82484H16.8601C17.9095 3.82484 18.7601 4.6755 18.7601 5.72484V16.1748C18.7601 17.2242 17.9095 18.0748 16.8601 18.0748H3.56015C2.51081 18.0748 1.66016 17.2242 1.66016 16.1748V5.72484C1.66016 4.6755 2.51081 3.82484 3.56015 3.82484H5.461V2.4248ZM3.56273 16.1751V5.72509H16.8627V16.1751H3.56273Z"
            fill={fill || 'white'}/>
      <rect x="1.66016" y="7.52051" width="17.1" height="1.94123" fill={fill || 'white'}/>
    </svg>
  )
}

export default Icon(IconNewCalendar)
